export default __webpack_public_path__ + "static/media/Q07_春風吹拂搖擺的青綠色調.08f8e56e.mp4";